import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Message } from "../../../../../../models/message";
import { MessageControllerService } from "../../../../../../services/message-controller/message-controller.service";
import { RoleStatusService } from "../../../../../../services/role-controller/role-status.service";
import { ServiceControllerService } from "../../../../../../services/service-controller/service-controller.service";
import { TagControllerService } from "../../../../../../services/form-controller/tag-controller.service";
import { Store } from "../../../../../../services/store.service";
import * as _ from "lodash";
import { TranslatedBaseError } from "../../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";

import "../../../../../../../assets/libs/ckeditor5/build/translations/es";
import "../../../../../../../assets/libs/ckeditor5/build/translations/fr";
import "../../../../../../../assets/libs/ckeditor5/build/translations/ar";
import "../../../../../../../assets/libs/ckeditor5/build/translations/et";
import { ClassicEditor } from "../../../../../../../assets/libs/ckeditor5";

@Component({
  selector: "message-edit",
  templateUrl: "./message-edit.component.html",
  styles: [],
  providers: [MessageControllerService, ServiceControllerService, ToastrService, TagControllerService],
})
export class MessageEditComponent extends TranslatedBaseError implements OnInit, OnChanges {

  @Input() public serviceId: string;
  @Input() public isAlert: boolean = false;
  public currentMessage: Message;
  @Input() set message(value: Message) {
    this.currentMessage = Object.assign({}, value);
  }
  @Input() public disableType: boolean = false;
  @Input() public context: string = "role";
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  public statusRegistrations: any[] = [];
  public statusRegistrationIds: any[] = [];
  public isLoading: boolean = false;
  public moustachHelper: boolean = false;
  public moustacheFilter: string;
  public msgBody: any; // TODO: html requires it
  public moustaches: any[] = [
    "listing-value",
    "company-name",
    "rejection-reasons",
    "uploaded-documents",
    "requested-registrations",
    "userid",
    "username",
    // "userfullname",
    "applicantusername",
    "applicantuserid",
    "applicantfullname",
    "applicant-email",
    "applicant-phone",
    "starterEmail",
    "file-rejected",
  ];
  public licenesesTags: any[];
  public formattedLicenesesTags: any[] = [];

  public availableChannels: Array<{ id: string, name: string, disabled?: boolean, icon?: string }> = [
    { id: "EMAIL", name: "Email", disabled: false, icon: "envelope" },
    { id: "SMS", name: "SMS", disabled: false, icon: "mobile" },
    { id: "WHATSAPP", name: "WhatsApp", disabled: true, icon: "comments" },
  ];

  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        "heading",
        "|",
        "fontFamily",
        "fontSize",
        "fontColor",
        "underline",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "alignment",
        "outdent",
        "indent",
        "|",
        "imageUpload",
        "blockQuote",
        "insertTable",
        // "mediaEmbed",
        "undo",
        "redo",
        "|",
        "horizontalLine",
        "|",
        "removeFormat",
        "htmlEmbed",
      ],
    },
    language: this.store.state.common.lang,
    image: {
      toolbar: [
        "imageTextAlternative",
        "imageStyle:full",
        "imageStyle:side",
        "linkImage",
      ],
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties",
      ],
    },
  };

  constructor(toastr: ToastrService,
    public store: Store,
    private messageControllerService: MessageControllerService,
    public tagControllerService: TagControllerService,
    private roleStatusService: RoleStatusService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.getTags();
    if (this.currentMessage && !this.currentMessage.channel) {
      this.currentMessage.channel = "EMAIL";
    }
  }

  public getTags() {
    this.tagControllerService.getServiceTagList(this.serviceId).subscribe(
      (data) => {
        this.licenesesTags = data;
        this.makeTagsList(data);
      },
    );
  }

  public makeTagsList(data) {
    const tempTags = [];
    _.forEach(data, (d) => {
      d.name = d.name.replace("License URL", "URL");
      tempTags.push(d.name);
      this.formattedLicenesesTags.push(d);
    });
    this.moustaches = _.union(tempTags, this.moustaches);
    this.moustaches.sort((a, b) => {
      const nameA = a.toLowerCase();
      const nameB = b.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
    });
  }

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.serviceId && changes.serviceId.currentValue) {
      this.serviceId = changes.serviceId.currentValue;
    }
    this.initRegistrations();
  }

  public initRegistrations() {
    if (this.currentMessage && this.currentMessage.roleRegistrations) {
      this.statusRegistrations = [];
      this.statusRegistrationIds = [];
      this.currentMessage.roleRegistrations.forEach((item) => {
        this.statusRegistrations.push({ id: item.id, text: item.name });
        this.statusRegistrationIds.push(item.id);
      });
    }
    if (this.currentMessage.id === undefined) {
      if (!this.isAlert) {
        this.currentMessage.messageType = "MESSAGE";
      } else {
        this.currentMessage.messageType = "ALERT";
      }
    }
  }

  public updateChannel(channel: string) {
    this.currentMessage.channel = channel;
  }

  public submit() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (this.currentMessage.id === undefined) {
        this.setMessageCode();
        this.createMessage(this.currentMessage);
      } else {
        this.saveMessage(this.currentMessage);
      }
    }
  }

  public setMessageCode(): string {
    return this.currentMessage.messageType === "MESSAGE" ? this.currentMessage.code = "MESSAGE_" + this.getRandomCode() : this.currentMessage.code = "ALERT_" + this.getRandomCode();
  }

  public createMessage(message: Message) {
    message.name = message.subject;
    this.messageControllerService.createMessage(message).subscribe(
      () => {
        this.responseSuccessful("Message created!");
        if (this.context === "role") {
          this.roleStatusService.updateListData();
          this.formSubmit.emit({ save: true });
          this.closeLayer();
        } else {
          this.formSubmit.emit();
        }
      },
      (error) => {
        if (error.error && error.error.errors) {
          this.showErrorMessage(error.error.errors[0].field + " " + error.error.errors[0].defaultMessage);
        } else {
          this.showErrorMessage(error);
        }
      },
      () => this.isLoading = false,
    );
  }

  public saveMessage(message: Message) {
    message.name = message.subject;
    this.messageControllerService.saveMessage(message).subscribe(
      () => {
        this.responseSuccessful("Message saved!");
        if (this.context === "role") {
          this.roleStatusService.updateData();
          this.formSubmit.emit({ save: true, message });
          this.closeLayer();
        } else {
          this.formSubmit.emit();
        }
      },
      (error) => {
        if (error.error && error.error.errors) {
          this.showErrorMessage(error.error.errors[0].field + " " + error.error.errors[0].defaultMessage);
        } else {
          this.showErrorMessage(error);
        }
      },
      () => this.isLoading = false,
    );
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
  }

  public addMoustach(moustache) {
    const m = _.find(this.formattedLicenesesTags, { name: moustache });
    const position = (document.getElementsByClassName("ck-content")[0] as HTMLInputElement).selectionStart;
    const tag = " {{" + (m && m.key && m.key.indexOf("license-url") !== -1 ? (m.key) : moustache) + "}}";
    this.currentMessage.content = this.currentMessage.content.slice(0, position) + tag + this.currentMessage.content.slice(position);
  }

  public getRandomCode(): string {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  public get smsLimit(): number {
    return 160;
  }

  public get messageLength(): number {
    return this.currentMessage.content ? this.currentMessage.content.length : 0;
  }

  public get isSmsLimitExceeded(): boolean {
    return this.currentMessage.channel === "SMS" && this.messageLength > this.smsLimit;
  }
}
